/**
 * Common API response types for the application
 */
import { User, Device, Parking, Payment, Tenant } from '@/services/letsparkyClient';

// Generic API response structure
export interface ApiResponse<T> {
  data: T;
  error?: string;
  message?: string;
  status?: number;
}

// Paginated list response
export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
  hasMore?: boolean;
}

// List response with nested data structure
export interface ListResponse<T> {
  data: T[];
  total?: number;
  error?: string;
}

// Login response
export interface LoginResponse {
  token: string;
  user: User;
}

// Error response
export interface ApiError {
  message: string;
  status?: number;
  code?: string;
  details?: Record<string, any>;
}

// Helper to safely handle API errors
export const handleApiError = (error: unknown): string => {
  if (error instanceof Error) return error.message;
  if (typeof error === 'object' && error !== null && 'message' in error) {
    return (error as ApiError).message;
  }
  return 'An unknown error occurred';
};

// Re-export entity types
export type { User, Device, Parking, Payment, Tenant }; 